// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormError-module__error___cWUdF{display:block;color:#b81237;margin-top:.5rem;padding-left:1.75rem;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle fill='%23c60c30' cx='8' cy='8' r='8'/%3E%3Cpath fill='%23fff' d='M4.994 4L4 4.994 7.006 8 4 11.006l.994.994L8 8.994 11.006 12l.994-.994L8.994 8 12 4.994 11.006 4 8 7.006z'/%3E%3C/svg%3E\") no-repeat 0 4px}", ""]);
// Exports
exports.locals = {
	"error": "FormError-module__error___cWUdF"
};
module.exports = exports;
